// extracted by mini-css-extract-plugin
export default {"block":"StartBlock_block__e93rz","title":"StartBlock_title__DOp+N"};